import React from 'react';
import { TCITooltip } from '@/components/ui/Tooltip';
import cn from '@/utils/cn';
import { HEADER_BUTTON_CLASSES, TRANSLATIONS } from './utils';
import Icon from '@/components/ui/Icon';

interface PrintPdfButtonProps {
  printPdfPath: string;
}

export const PrintPdfButton = ({ printPdfPath }: PrintPdfButtonProps) => (
  <TCITooltip>
    <TCITooltip.Trigger asChild>
      <a
        aria-label={TRANSLATIONS.printMessage}
        className={cn(HEADER_BUTTON_CLASSES, 'tw-p-1')}
        href={printPdfPath}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon icon="Print" size={16} />
      </a>
    </TCITooltip.Trigger>
    <TCITooltip.Content>
      {TRANSLATIONS.printMessage}
    </TCITooltip.Content>
  </TCITooltip>
);
